import * as actions from '../../constants';

// This is used to identify which element we dispatch the custom event on.
export const appContainerId = 'nna-payment-estimator';
export const customEventName = 'reduxAction';

/**
 * This is a collection of redux action types that are pushed through to DTM,
 * usually it means that they are system actions that aren't prefixed with the normal
 * prefix but should also be logged.
 */
export const mksWhitelist = [
  actions.INIT_ESTIMATOR_APP,
  actions.UPDATE_ROUTE_PARAMS,
  actions.LINK,
  actions.DEALER_QUERY_SUCCESS,
  actions.LEAD_SUBMISSION_SUCCESS
]

// action prefix
export const actionPrefix = 'USER_';

// get all the actions that start with _USER
const actionNames = Object.keys(actions);
const allUserActionsNames = actionNames.filter(actionName => actionName.startsWith(actionPrefix));
export const allUserActions = allUserActionsNames.map(name => actions[name]);



/** WEBPACK FOOTER **
 ** ./src/redux/middleware/analytics/constants.js
 **/